export const petTypes: any = [
  {
    value: "1",
    label: "Otro",
  },
  {
    value: "2",
    label: "Perro",
  },
  {
    value: "3",
    label: "Gato",
  },
  {
    value: "4",
    label: "Ave",
  },
  {
    value: "5",
    label: "Reptil",
  },
  {
    value: "6",
    label: "Anfibio",
  },
  {
    value: "7",
    label: "Pez",
  },
  {
    value: "8",
    label: "Roedor",
  },
];

export const establishments: any = [
  { value: 1, label: "Oficina" },
  { value: 2, label: "Residencia" },
  { value: 3, label: "Local Comercial" },
];

export const UNIT_TYPES = [
  {
    name: "-",
    display_name: "-",
  },
  {
    name: "OFFICES",
    display_name: "Oficina",
  },
  {
    name: "RESIDENCES",
    display_name: "Residencia",
  },
  {
    name: "COMMERCIAL_PREMISES",
    display_name: "Local comercial",
  },
  {
    name: "WAREHOUSES",
    display_name: "Bodega",
  },
];

export const PET_TYPES = [
  { name: "-" },
  { name: "Otro" },
  { name: "Perro" },
  { name: "Gato" },
  { name: "Pájaro" },
  { name: "Reptil" },
  { name: "Anfibio" },
  { name: "Pez" },
  { name: "Roedor" },
];

export const FireExtinguisherType = [
  { value: 1, label: "SOLIDO" },
  { value: 2, label: "LIQUIDO" },
  { value: 3, label: "ELECTRICO" },
  { value: 4, label: "METAL" },
  { value: 5, label: "GRASOS" },
];
